import store from './store/'
import axios from 'axios'
import FileDownload from 'js-file-download'

const urlPrefix = '/api/app/'

let eventBus = null

export function resgitserBus (bus) {
  eventBus = bus
}

axios.interceptors.request.use(
  config => {
    let storageEId = Number.parseInt(localStorage.getItem('eId') || 0)
    if (
      store.state.currentAccount.eId > 0 &&
      storageEId !== store.state.currentAccount.eId &&
      eventBus
    ) {
      eventBus.$emit('accountChanged')
      return Promise.reject
    }

    // console.log(store.state.oauth.accessToken)
    if (store.state.oauth.accessToken) {
      config.headers.Authorization = store.state.oauth.accessToken
    }

    // console.log(store.state.oauth.account)
    if (store.state.currentAccount.eId > 0) {
      config.headers['IWE-EID'] = store.state.currentAccount.eId
    } else if (storageEId) {
      config.headers['IWE-EID'] = storageEId
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      if (error.response.status === 401) {
        eventBus.$emit('unlogin')
        return Promise.reject(error)
      }

      if (error.response.status === 429) {
        eventBus.$emit('apiTooMany')
        return Promise.reject(error)
      }
      if (error.response.status === 500) {
        const data = error.response.data
        let messages
        try {
          messages = JSON.parse(data)
        } catch (err) {
          messages = data
        }

        // other errors
        if (messages instanceof Object) {
          messages = messages.message || ''
          if (messages instanceof Array) {
            messages = messages
              .map(item => {
                return `<p>${item}</p>`
              })
              .join('')
          }
        }
        eventBus.$emit('processError', messages)
      } else {
        eventBus.$emit('processError', error.response.data)
      }
    } else {
      eventBus.$emit('processError', 'Http Error')
    }
    return Promise.reject(error)
  }
)

/* eslint-enable */

async function get (url, param = {}) {
  const response = await axios.get(urlPrefix + url, {
    params: param
  })
  return response.data
}

async function post (url, param = {}) {
  const response = await axios.post(urlPrefix + url, param)
  return response.data
}

async function put (url, id, param = {}) {
  url = url.replace(/\/+$/, '')
  const response = await axios.put(`${urlPrefix}${url}\\${id}`, param)
  return response.data
}

async function del (url, id) {
  url = url.replace(/\/+$/, '')
  const response = await axios.delete(`${urlPrefix}${url}\\${id}`)
  return response.data
}

/** API */
export const login = async (email, password) => {
  const param = {
    grant_type: 'password',
    client_id: 2,
    client_secret: 'N4C8SzP06ujbi0R40WRVZ55v73tSO1x4HCXbVpyX',
    username: email,
    password: password,
    scope: ''
  }
  const response = await axios.post('/oauth/token', param)
  return response.data
}

export const getAccounts = async () => {
  return get('allaccs')
}

export const getBrands = async () => {
  return get('brands', { all: true })
}

export const getBrandsPaginate = async (param = {}) => {
  return get('brands', param)
}

export const getWarehouses = async () => {
  return get('warehouses', { all: true })
}

export const getWarehousesPaginate = async (param = {}) => {
  return get('warehouses', param)
}

export const getStaff = async () => {
  return get('employees', { all: true })
}

export const getStaffPaginate = async (param = {}) => {
  return get('employees', param)
}

export const getCustomers = async (param = {}) => {
  return get('customers', param)
}

export const getSuppliers = async (param = {}) => {
  return get('suppliers', { all: true, ...param })
}

export const getSuppliersPaginate = async (param = {}) => {
  return get('suppliers', param)
}
export const getBalance = async id => {
  return get('balance/' + id)
}

export const getProductsInfo = async (param = {}) => {
  return get('products', param)
}

export const getProduct = async id => {
  return get(`products/${id}`)
}

export const getQuotings = async (param = {}) => {
  return get('quotings', param)
}

export const getOcops = async (param = {}) => {
  return get('ocops', param)
}

export const getOrders = async (param = {}) => {
  return get('orders', param)
}

export const getOrder = async id => {
  return get(`orders/${id}`)
}

export const postOrder = async (param = {}) => {
  return post('orders', param)
}

export const putOrder = async (id, param = {}) => {
  return put('orders', id, param)
}

export const deleteOrder = async id => {
  return del('orders', id)
}

export const orderApprove = async (id, param = {}) => {
  return post(`orders/${id}/approve`, param)
}

export const orderUnApprove = async (id, param = {}) => {
  return post(`orders/${id}/unApprove`, param)
}

export const orderVoid = async (id, param = {}) => {
  return post(`orders/${id}/void`, param)
}

export const orderClose = async (id, param = {}) => {
  return post(`orders/${id}/close`, param)
}

export const orderNext = async (id, param = { type: 'next' }) => {
  return get('order-next', { id, ...param })
}

export const productHistory = async (id, cId = 0) => {
  const param = {}
  if (cId > 0) {
    param.cId = cId
  }

  return get(`products/${id}/history`, param)
}

export const orderHistory = async id => {
  return get(`orders/${id}/history`)
}

export const orderDateModify = async (id, param) => {
  return post(`orders/${id}/date`, param)
}

export const orderAddressModify = async (id, param) => {
  return post(`orders/${id}/address`, param)
}

export const orderDriverModify = async (orderId, driverId) => {
  return post(`delivery`, {
    type: 1,
    data: [{
      order_id: orderId,
      info: driverId
    }]
  })
}

export const ocopDetail = async id => {
  return get(`ocops/${id}`)
}

export const modifyDetail = async (id, param) => {
  return put('ocops', id, param)
}

export const getAreaTypes = async () => {
  return get('area-types')
}

export const getPaymentTypes = async () => {
  return get('payment-types')
}

export const reportQuery = async params => {
  return post('reports', params)
}

export const reports = async () => {
  return get('reports')
}

export const download = async (id, fileName) => {
  axios({
    method: 'get',
    url: `${urlPrefix}download/${id}`,
    responseType: 'blob'
  }).then(response => {
    FileDownload(response.data, fileName)
  })
}

export const orderDownload = async (params, fileName) => {
  axios({
    method: 'get',
    url: `${urlPrefix}orders`,
    params: params,
    responseType: 'blob'
  }).then(response => {
    FileDownload(response.data, fileName)
  })
}

export const productDownload = async (params, fileName) => {
  axios({
    method: 'get',
    url: `${urlPrefix}products`,
    params: params,
    responseType: 'blob'
  }).then(response => {
    FileDownload(response.data, fileName)
  })
}

export const csrDownload = async (params, fileName) => {
  axios({
    method: 'get',
    url: `${urlPrefix}customers`,
    params: params,
    responseType: 'blob'
  }).then(response => {
    FileDownload(response.data, fileName)
  })
}

export const orderSendXero = async id => {
  return post(`xero/${id}/order`, {})
}
export const orderRecallFromXero = async id => {
  return post(`xero/${id}/recall`, {})
}

export const batchSendXero = async param => {
  return post('xero', param)
}

export const markPrint = async id => {
  return post(`orders/${id}/print`, {})
}

export const changePassword = async password => {
  return post('password', { password })
}

export const changeProductPrice = async (id, params) => {
  return post(`products/${id}/price`, params)
}

export const changeProductTag = async (id, params) => {
  return post(`products/${id}/tag`, params)
}

export const postProduct = async params => {
  return post('products', params)
}

export const updateProduct = async (id, params) => {
  return put('products', id, params)
}

export const getCustomer = async id => {
  return get(`customers/${id}`)
}

export const postCsr = async params => {
  return post('customers', params)
}

export const updateCsr = async (id, params) => {
  return put('customers', id, params)
}

export const getPrintInfo = async () => {
  return get('printInfo')
}

export const getCsrSelfOrderCnt = async () => {
  return get('incomeorders')
}
